import "./FilterCamOutput.css";
import ARCamera from "./ARCamera";
import { useParams } from 'react-router-dom';

const FilterCamOutput = () => {
  const { eventId } = useParams();
  
  return (
    <div className="filtercam-placeholder-container">
      <ARCamera eventId={eventId} />
    </div>
  );
};

export default FilterCamOutput;
